"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GameSetGamesList_1 = require("./GameSetGamesList");
var GameSetGamesBotWinsList_1 = require("./GameSetGamesBotWinsList");
var GameSetGamesBotWinsEditor_1 = require("./GameSetGamesBotWinsEditor");
var GameSetOperations = /** @class */ (function (_super) {
    __extends(GameSetOperations, _super);
    function GameSetOperations(props) {
        return _super.call(this, props) || this;
    }
    GameSetOperations.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_BWT = this.props.listBotWinTypes.Subscribe("*", function (id, data) {
            _this.setState({
                avail_botwintypes: data.data,
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            botWinRecord: null,
            avail_botwintypes: []
        }, function () {
            _this.props.listBotWinTypes.LoadData();
        });
    };
    GameSetOperations.prototype.componentWillUnmount = function () {
        this.props.listBotWinTypes.UnSubscribe(this.SID_BWT);
    };
    GameSetOperations.prototype.onRobotWinnersConfigClick = function (val) {
        this.setState({
            edit_mode: "BOT-WIN-LIST",
            record: val
        });
    };
    GameSetOperations.prototype.onGoBackToBotWinsListClick = function () {
        this.setState({
            edit_mode: "BOT-WIN-LIST",
        });
    };
    GameSetOperations.prototype.onGoToWinsListClick = function () {
        this.setState({
            edit_mode: "LIST",
            record: null
        });
    };
    GameSetOperations.prototype.onNewBotWinClick = function () {
        this.setState({
            edit_mode: "BOT-WIN-NEW"
        });
    };
    GameSetOperations.prototype.onEditBotWinClick = function (record) {
        this.setState({
            edit_mode: "BOT-WIN-EDIT",
            botWinRecord: record
        });
    };
    GameSetOperations.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(GameSetGamesList_1.default, { data: this.props.data, state: this.props.state, record: this.props.record, onGoBackClick: this.props.onGoBackClick.bind(this), dlgNumericEditor: this.props.dlgNumericEditor, currencyId: this.props.currencyId, allCurrency: this.props.allCurrency, availCurrency: this.props.availCurrency, onCurrencyFilterChanged: this.props.onCurrencyFilterChanged.bind(this), dlgGameEdit: this.props.dlgGameEdit, onRobotWinnerConfigClick: this.onRobotWinnersConfigClick.bind(this) }));
        }
        if (this.state.edit_mode === "BOT-WIN-LIST") {
            return (React.createElement(GameSetGamesBotWinsList_1.default, { state: this.props.state, data: this.props.botWinsData, rootRecord: this.props.record, onNewClick: this.onNewBotWinClick.bind(this), onEditClick: this.onEditBotWinClick.bind(this), onGoBack: this.onGoToWinsListClick.bind(this) }));
        }
        if (this.state.edit_mode === "BOT-WIN-NEW") {
            return (React.createElement(GameSetGamesBotWinsEditor_1.default, { state: this.props.state, data: this.props.botWinsData, rootRecord: this.props.record, record: null, availBotWinTypes: this.state.avail_botwintypes, appCurrencyId: this.props.currencyId, onGoBack: this.onGoBackToBotWinsListClick.bind(this) }));
        }
        if (this.state.edit_mode === "BOT-WIN-EDIT") {
            return (React.createElement(GameSetGamesBotWinsEditor_1.default, { state: this.props.state, data: this.props.botWinsData, rootRecord: this.props.record, record: this.state.botWinRecord, availBotWinTypes: this.state.avail_botwintypes, appCurrencyId: this.props.currencyId, onGoBack: this.onGoBackToBotWinsListClick.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    GameSetOperations.prototype.render = function () {
        return this.getRenderObject();
    };
    return GameSetOperations;
}(React.Component));
exports.default = GameSetOperations;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_gamesets_list/ui/component/GameSetOperations.tsx
// module id = 2000
// module chunks = 0